// Temporary instrumentation for the Popper.tsx:84 infinite-render loop
// on /user/[userId]/boards. Each instrumented component calls
// `useDebugRenderLoop("ComponentName", instanceLabel)` at the TOP of its
// render. A per-instance ref-counter increments every render; warnings
// fire at 30 renders (suspicious) and every 100 after (confirming loop +
// counting how bad).
//
// Remove this file (and all useDebugRenderLoop call sites) once the
// culprit is identified and patched.

import { useRef } from "react";

export function useDebugRenderLoop(component: string, instance: string) {
  const count = useRef(0);
  count.current++;
  const n = count.current;
  if (n === 30) {
    // eslint-disable-next-line no-console
    console.warn(
      `[render-loop?] ${component}[${instance}] hit 30 renders — suspicious`,
    );
  } else if (n > 30 && n % 100 === 0) {
    // eslint-disable-next-line no-console
    console.warn(
      `[render-loop] ${component}[${instance}] render #${n} (LOOPING)`,
    );
  }
}
